export const ASSET_NAVIGATION_LIST = 'ASSET_NAVIGATION_LIST'